import moment from 'moment';
import {
  AllocationForProject,
  OverAllocationApi,
  ResourceType,
} from 'api/resource-management/types';
import { INVALID_ROLE_ID } from 'components/organisms/resource-management/utils/common';
import {
  resourceIdForTeamAsLeaf,
  resourceIdForUserAsLeaf,
} from 'components/organisms/resource-management/utils/id';
import { overAllocationsAsUIFormat } from 'components/organisms/resource-management/utils/overallocation';
import { numberOfWorkingDaysBetweenDates } from 'components/organisms/timesheets/common/utils';
import { AllocationEvent, SchedulerEventType } from '../../event-types';
import { ExcludeNonWorkingDaysParam } from '../../types';
import { getSchedulerEventProps, getSchedulerEventsClass } from './common';

export const allocationForProjectAsEvent = (
  allocation: AllocationForProject,
  projectId: number,
  overAllocations: OverAllocationApi[],
  exclusionParam: ExcludeNonWorkingDaysParam,
  softAllocationsEnabled?: boolean,
): AllocationEvent => ({
  type: SchedulerEventType.Allocation,
  id: allocation.id,
  ...(allocation.type === ResourceType.User
    ? {
        resourceId: resourceIdForUserAsLeaf({
          projectId,
          userId: allocation.user.userId,
          roleId: allocation.role?.roleId,
          referenceTeamId: allocation.referenceTeam?.teamId,
        }),
        userId: allocation.user.userId,
        roleId: allocation.role?.roleId,
        referenceTeamId: allocation.referenceTeam?.teamId,
      }
    : {
        resourceId: resourceIdForTeamAsLeaf(projectId, allocation.team.teamId),
        teamId: allocation.team.teamId,
        roleId: allocation.team.roleId ?? INVALID_ROLE_ID,
      }),
  startDate: moment(allocation.startDate).startOf('day').toDate(),
  endDate: moment(allocation.endDate).endOf('day').toDate(),
  totalMinutes:
    numberOfWorkingDaysBetweenDates(
      moment(allocation.startDate).startOf('day'),
      moment(allocation.endDate).endOf('day'),
      exclusionParam.workingDaysConfig,
    ) * allocation.minutes,
  minutes: allocation.minutes,
  projectPhase: allocation.projectPhase,
  billable: allocation.billable,
  projectId,
  overAllocations,
  overAllocationsForUI: overAllocationsAsUIFormat(overAllocations),
  medium: allocation.medium,
  ...getSchedulerEventProps(SchedulerEventType.Allocation, {
    cls: getSchedulerEventsClass(
      SchedulerEventType.Allocation,
      `${softAllocationsEnabled ? allocation.medium : ''}`.toLowerCase(),
    ),
  }),
});
